import { Validators } from "@angular/forms";
import { AssignmentService } from "../../../assignment/core/assignment.service";
import { Assignment } from "../../../assignment/shared/assignment";
import { FormButtonType, FormConfig, FormField } from "./form-config-abstract";

export class FormConfigEditInlineAssignment extends FormConfig<Assignment>{
    constructor(private assignmentService : AssignmentService){
      super();
    }

    apiService = () => this.assignmentService;

    listId : number | string;

    buttons : FormButtonType[] = ["CANCEL", "SAVE"];

    init(listId? : number | string){
        this.listId = listId;
        super.fieldsInit(this);
    }

    fields : FormField<Assignment>[] = [
      {
        name : 'title',
        label : 'assignment.edit.title',
        required : true,
        type : "text",
        validators : [Validators.maxLength(250)],
        main : true
      },
      {
        name : 'description',
        label : 'assignment.edit.instructions',
        type : 'textarea',
        validators : [Validators.maxLength(3500)]
      }
    ]
}
